import React, { useContext, useState, useEffect } from 'react';

import { observer } from 'mobx-react-lite';
import { useLocation } from 'react-router-dom';
import dayjs from 'dayjs';

import { RootStoreContext } from 'index';
import Button from 'components/common/Button/Button';
import { CompanyProfileDto } from 'components/intermediaryApplications/intermediaryApplications.dto';
import SideBar from 'components/common/SideBar/SideBar';
import Consent from 'components/common/Consent/Consent';
import { ApplicationRoute } from 'routes/routes.enums';

import styles from './ConsentDialog.module.scss';

// TODO I think we should refactor this components because ConsentDialog doesn't need to control and check permission
const ConsentDialog = () => {
  const [open, setOpen] = useState(false);
  const [isChecked, setChecked] = useState(false);
  const { intermediaryApplicationsStore } = useContext(RootStoreContext);
  const intermediary = (intermediaryApplicationsStore.companyProfile as CompanyProfileDto) || {};
  const location = useLocation();

  useEffect(() => {
    const canShowConsent = intermediary.consentHiddenUntil ? dayjs().isAfter(intermediary.consentHiddenUntil) : true;

    if (
      intermediary &&
      canShowConsent &&
      location.pathname !== ApplicationRoute.ConfirmEmail &&
      (!intermediary.isFullConsentSigned || !intermediary.isTransactionalConsentSigned)
    ) {
      setOpen(true);
    } else {
      setOpen(false);
    }
  }, [
    intermediary.isFullConsentSigned,
    intermediary.isTransactionalConsentSigned,
    intermediary.consentHiddenUntil,
    location.pathname,
  ]);

  const handleAgree = async () => {
    await intermediaryApplicationsStore.updateConsent({
      isFullConsent: intermediary.isTransactionalConsentSigned ? true : isChecked,
    });
    setOpen(false);
    await intermediaryApplicationsStore.getCompanyProfile();
  };

  const handleClose = async () => {
    await intermediaryApplicationsStore.updateConsent({ isOnlyViewed: true });
    setOpen(false);
    await intermediaryApplicationsStore.getCompanyProfile();
  };

  return (
    <SideBar isOpen={open} enableBackdropClick={false} showCloseIcon={false} onClose={handleClose}>
      <Consent
        isShowTransactionalConsent={!intermediary.isTransactionalConsentSigned}
        onChange={() => {
          setChecked(!isChecked);
        }}
      />
      <div className={styles.buttons}>
        <Button className={styles.button} onClick={handleAgree} isLoading={intermediaryApplicationsStore.isLoading}>
          I Agree
        </Button>
        {intermediary.isTransactionalConsentSigned && (
          <Button
            className={styles.button}
            onClick={handleClose}
            variant="white"
            isLoading={intermediaryApplicationsStore.isLoading}
          >
            I do not consent
          </Button>
        )}
      </div>
    </SideBar>
  );
};

export default observer(ConsentDialog);
